import { css } from "@emotion/css";
import styled from "@emotion/styled";
import { Colors, Spacing } from "@snapchat/snap-design-system";

export const TagsWrapper = styled.div`
    margin-bottom: 16px;
`;

export const addButtonContainerStyle = css`
    width: 60px;
    height: 40px;

    background: ${Colors.Gray.V50};
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
`;

export const addTagButtonStyle = css`
    cursor: pointer;

    font-size: 12px;
    font-weight: 500;
    line-height: 12px;
    color: ${Colors.Blue.V100};

    transition: 170ms ease;

    :hover,
    :focus {
        transform: scale(1.07);
    }
`;

export const removeTag = css`
    cursor: pointer;

    min-width: 8px;
    min-height: 8px;
    margin: -1px 0 0 7px;

    transition: 230ms ease;

    :hover,
    :focus {
        transform: scale(1.16);
    }
`;

export const Tag = styled.div`
    display: flex;
    align-items: center;

    height: 20px;
    margin-top: ${Spacing.XS}px;
    margin-right: ${Spacing.XS}px;
    padding: ${Spacing["2XS"]}px ${Spacing.XS}px;

    background-color: ${Colors.Gray.V150};
    border-radius: ${Spacing["2XS"]}px;

    transition: background-color 230ms ease;

    :hover,
    :focus {
        background-color: #e3e4e5;
    }
`;

export const TagName = styled.span`
    font-size: 11px;
    font-weight: 500;
    line-height: 12px;
    color: ${Colors.Black.V100};
    letter-spacing: 0.2px;
`;

export const InputContainer = styled.div`
    display: flex;
    justify-content: center;
    width: 100%;
`;

export const TagsInputContainer = styled.div`
    width: 100%;
`;
